import PropTypes from "prop-types";
import React, { Component } from "react";
import ControlButton from "ControlButton";
import classnames from "classnames";
import styles from "./MobileChapterNumbers.css";
import ChapterButtonContainer from "../../containers/ChapterButtonContainer";
import { ChapterNavigationButton } from "../ChapterNavigationButton";

export default class MobileChapterNumbers extends Component {
  static propTypes = {
    border: PropTypes.bool,
    chapterId: PropTypes.number.isRequired,
    financedUnlockedNavigationArrows: PropTypes.bool.isRequired,
    mobileSizing: PropTypes.bool,
    onChapterNextClick: PropTypes.func.isRequired,
    onChapterPreviousClick: PropTypes.func.isRequired,
    showChapterNumber: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    border: false,
    mobileSizing: false,
  };

  render() {
    const rootClassname = classnames(`${styles.root} mobile-chapter-numbers`, {
      [styles.mobileSizing]: this.props.mobileSizing,
    });

    return (
      <div className={rootClassname} style={this.rootContainerStyles}>
        <div className={styles.container}>
          <ControlButton
            aria-label="previous chapter"
            border={this.props.border}
            onClick={this.props.onChapterPreviousClick}
            text=""
          >
            <ChapterNavigationButton
              className={styles.icon}
              direction="back"
              financeUnlockedStyle={this.props.financedUnlockedNavigationArrows}
            />
          </ControlButton>
          {this.props.showChapterNumber && (
            <ChapterButtonContainer
              chapterId={this.props.chapterId}
              disabled={false}
              key={`${this.props.chapterId}`}
              on
            />
          )}
          <ControlButton
            aria-label="next chapter"
            border={this.props.border}
            onClick={this.props.onChapterNextClick}
            text=""
          >
            <ChapterNavigationButton
              className={styles.icon}
              direction="forward"
              financeUnlockedStyle={this.props.financedUnlockedNavigationArrows}
            />
          </ControlButton>
        </div>
      </div>
    );
  }
}
